// File upload size limits (phải đồng bộ giữa client và server)
export const MAX_IMAGE_SIZE = 5 * 1024 * 1024; // 5MB cho ảnh
export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB cho file

// Timeout settings
export const API_REQUEST_TIMEOUT = 30 * 1000; // 30 giây
export const API_UPLOAD_TIMEOUT = 2 * 60 * 1000; // 2 phút

// UI thresholds
export const SLOW_LOAD_THRESHOLD = 3000; // 3 giây before show "đang tải"
export const VERY_SLOW_LOAD_THRESHOLD = 15000; // 15 giây = very slow

// Toast & notification
export const TOAST_AUTO_HIDE_DURATION = 5000; // 5 giây
export const SLOW_NETWORK_MESSAGE_DELAY = 10000; // 10 giây before show "slow network"
